import { computed } from 'mobx';
import * as React from 'react';
import { observer } from 'mobx-react';

import { ClientDataStore } from '../../stores/client-data.store';
import { HomeStore } from '../../stores/home.store';
import { HomePage } from './desktop/home-page';
import { lazyInject } from 'src/ioc';

@observer
export class HomePageContainer extends React.Component {
    @lazyInject(HomeStore) private homeStore!: HomeStore;
    @lazyInject(ClientDataStore) private clientData!: ClientDataStore;

    @computed get balance() {
        return this.homeStore.homeData ? this.homeStore.homeData.invoiceBalance : -1;
    }
    @computed get jobs() {
        return this.homeStore.homeData ? this.homeStore.homeData.jobCount : -1;
    }
    @computed get showPayText() {
        return this.homeStore.homeData
            ? !this.homeStore.homeData.creditCardDisabled ||
            !this.homeStore.homeData.creditCardDisabled
            : false;
    }
    @computed get customerName() {
        return this.clientData.loginData.customerName;
    }
    @computed get errorMessage() {
        return this.homeStore.errorMessage;
    }
    @computed get showRequestAppointment() {
        return (
            (this.clientData.isLoggedIn &&
                this.homeStore.homeData &&
                this.homeStore.homeData.schedulerEnabled) ||
            false
        );
    }
    @computed get isSavePaymentMethodsEnabled() {
        return this.clientData.isLoggedIn && this.homeStore.homeData &&
            (this.homeStore.homeData.saveCreditCardEnabled || this.homeStore.homeData.savePayByBankEnabled ||
                this.homeStore.homeData.saveAchEnabled
            );
    }

    constructor(props: {}) {
        super(props);
        this.homeStore.refreshHomeData();
    }

    clearError = () => {
        this.homeStore.clearError();
    };

    render() {
        return <HomePage container={this} />;
    }
}
